import Cookies, { type CookieAttributes } from 'js-cookie';

/** Matches CanJS cookie name and attributes (path/secure/sameSite; no Domain). */
export const VT_ON_BEHALF_OF_COOKIE = 'VT-On-Behalf-Of';

const VT_ON_BEHALF_OF_COOKIE_OPTS: CookieAttributes = {
  path: '/',
  secure: true,
  sameSite: 'None',
};

export function getVtOnBehalfOfCookie(): string | undefined {
  return Cookies.get(VT_ON_BEHALF_OF_COOKIE);
}

export function setVtOnBehalfOfCookie(accountId: string): void {
  Cookies.set(VT_ON_BEHALF_OF_COOKIE, accountId, VT_ON_BEHALF_OF_COOKIE_OPTS);
}

export function removeVtOnBehalfOfCookie(): void {
  Cookies.remove(VT_ON_BEHALF_OF_COOKIE, VT_ON_BEHALF_OF_COOKIE_OPTS);
}

/**
 * Temporarily clears VT-On-Behalf-Of while running user-scoped work (e.g. language
 * prefs), then restores it. Mirrors CanJS user-interface-view-model.js.
 */
export async function withClearedVtOnBehalfOfWhenSwitchedAccount<T>(
  params: {
    userAccountId?: number | null;
    currentAccountId?: number | null;
  },
  fn: () => Promise<T>,
): Promise<T> {
  const { userAccountId, currentAccountId } = params;
  const isSwitched =
    userAccountId != null &&
    currentAccountId != null &&
    userAccountId !== currentAccountId;
  const existing = getVtOnBehalfOfCookie();

  if (isSwitched) {
    removeVtOnBehalfOfCookie();
  }

  try {
    return await fn();
  } finally {
    if (isSwitched && existing) {
      setVtOnBehalfOfCookie(existing);
    }
  }
}
